import axios from 'axios';

export const getCountryCode = () =>
  axios
    .get('https://api.db-ip.com/v2/pf64ec43b31c34c63576b037e3c74c09275692cf/self/countryCode')
    .then((res) => res.data);
